export interface IvrNodeCoordinates {
  x: number;
  y: number;
}

export interface IvrNodePosition {
  [nodeId: string]: IvrNodeCoordinates;
}

export class IvrTreeData {
  positions: IvrNodePosition;
  updatedAt?: string;
}
